import React, { useState, useRef, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/authenticationActions';
import { QrCodeIcon } from '@heroicons/react/20/solid';
import { ClipboardIcon, KeyIcon } from '@/icons/outline';
import { CodeInput, getSegmentCssWidth } from 'rci';
import { copyToClipboard } from "./helpers/ClipboardHelpers";

const MFASetup = ({
    mfa,
    initiateMFA,
    verifyMFA,
    logout,
    profileLoaded,
    companyRequired,
}) => {

    const inputRef = useRef(null);

    const [showQR, setShowQR] = useState(true);

    const width = getSegmentCssWidth('10px');

    useEffect(() => {
        if (profileLoaded) initiateMFA();
    }, [profileLoaded]);

    if(mfa.verified) return null;

    return (
        <>
            <div style={{ padding: "10px 20px 10px 25px" }}>
                {companyRequired ?
                    <h4 style={{ marginBottom: 20, textAlign: "center" }}>Your organisation requires you to set up MFA to access Buddy</h4>
                    : null
                }
                {(mfa.setup.qrImg &&
                    <>
                        <ol style={{ listStyle: "auto" }}>
                            <li>Download and open an authenticator app on your phone</li>
                            <li>Scan the Buddy QR Code on the app</li>
                        </ol>
                        {showQR ?
                            <img src={mfa.setup.qrImg} alt="QR Code" style={{ display: "block", marginLeft: "auto", marginRight: "auto", height: 150, width: 150, maxHeight: 150, maxWidth: 150 }} />
                            :
                            <div>
                                <input style={{ display: "inline-block" }} disabled value={mfa.setup.secret} />
                                <div
                                    className="btn btn-default"
                                    onClick={() => copyToClipboard(mfa.setup.secret)}
                                    style={{ marginLeft: 5 }}
                                >
                                    <ClipboardIcon style={{ height: "1.5em", float: "left" }} />
                                    <div style={{ float: "left" }}>Copy</div>
                                </div>
                            </div>
                        }
                        <div
                            className="btn btn-default"
                            onClick={() => setShowQR(!showQR)}
                            style={{ marginLeft: 5, marginBottom: 20 }}
                        >
                            {showQR ? <KeyIcon style={{ height: "1.5em", float: "left" }} /> : <QrCodeIcon style={{ height: "1.5em", float: "left" }} />}
                            <div style={{ float: "left", paddingLeft: 10 }}>{showQR ? "Show Setup Key" : "Show QR Code"}</div>
                        </div>
                        <div className="clearfix" />
                        <p>Once you've added the Multi-Factor Authentication (MFA) on your phone, insert the 6-digit key below.</p>
                        {/* Source from https://codesandbox.io/s/rci-codeinput-812up?file=/src/Example.tsx */}
                        <CodeInput
                            id="mfa-setup-key"
                            inputRef={inputRef}
                            length={6}
                            spellCheck={false}
                            inputMode='numeric'
                            pattern='[0-9]*'
                            style={{ height: 40, marginBottom: 10 }}
                            inputClassName="mfa-input"
                            className="mfa-div"
                            inputStyle={{ height: 40 }}
                            autoComplete='off'
                            onChange={({ currentTarget: input }) => {
                                // only accept numbers
                                input.value = input.value.replace(/\D+/g, '');

                                if (input.value.length === 6) verifyMFA(input.value);
                            }}
                            renderSegment={({ state, index }) => (
                                <div
                                    key={index}
                                    className='segment'
                                    data-state={state}
                                    style={{ width, flex: "none", height: '100%', border: "2px solid rgb(209, 213, 219)", borderRadius: "0.375rem" }}
                                    children={<div />}
                                />
                            )}
                        />
                        {companyRequired ?
                            <div className="font-s13 text-right push-5-t">
                                <a onClick={() => logout()} style={{ cursor: "pointer" }}>Nope, take me back</a>
                            </div>
                            : null
                        }
                    </>
                ) || (
                        "Loading..."
                    )
                }
            </div>
        </>
    );
}

const mapStateToProps = (state) => {

    return {
        mfa: state.my.mfa,
        profileLoaded: !!state?.my?.profile?.email,
    }
}

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch(ACTIONS.logout()),
    initiateMFA: () => dispatch(ACTIONS.initiateMFA()),
    verifyMFA: (code) => dispatch(ACTIONS.verifyMFA(code)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MFASetup);